const {subtractArray} = require('./utils')
const {sharedCommands, ANNOUNCEMENTS_LOCALSTORAGE_KEY} = require('./utils')
const {CXF_DIALOG_CLOSE} = require('./cxf-event-constants')
const {GET, GAME_CALLBACK} = require('./constants')

const {
    tracking,
    CLOSE_CROSS,
    CLOSE_REGULAR,
    DONT_SHOW_AGAIN_ACTIVATE,
    DONT_SHOW_AGAIN_DEACTIVATE,
    SCROLL,
    LOADED
} = require('./tracking')

let allActiveAnnouncements

function markAsRead({hash, wasRead}) {
    const doNotShowMessages = getDoNotShowMessages(hash.key)
    const eventName = wasRead
        ? DONT_SHOW_AGAIN_ACTIVATE
        : DONT_SHOW_AGAIN_DEACTIVATE
    for (const announcement of allActiveAnnouncements) {
        tracking(eventName, announcement)
    }

    const hiddenMessages = wasRead
        ? doNotShowMessages.concat(hash.hashList)
        : subtractArray(doNotShowMessages, hash.hashList)

    if (hiddenMessages.length === 0) {
        localStorage.removeItem(hash.key)
    } else {
        localStorage.setItem(hash.key, JSON.stringify(hiddenMessages))
    }
}

function closeFrame(context) {
    localStorage.removeItem(ANNOUNCEMENTS_LOCALSTORAGE_KEY)
    allActiveAnnouncements = undefined
    context.emit(CXF_DIALOG_CLOSE)
}

function getDoNotShowMessages(key) {
    const doNotShowMessages = localStorage.getItem(key) || '[]'
    return JSON.parse(doNotShowMessages)
}

function getMessages() {
    const messagesJSON =
        localStorage.getItem(ANNOUNCEMENTS_LOCALSTORAGE_KEY) || '[]'
    return JSON.parse(messagesJSON)
}

const sortByStartDate = (a, b) => b.start_date - a.start_date

function showAllMessages({frameId}) {
    const messages = getMessages().sort(sortByStartDate)

    if (messages && messages.length > 0) {
        // eslint-disable-next-line unicorn/prefer-query-selector
        const iframe = document.getElementById(frameId).contentWindow
        allActiveAnnouncements = messages
        const triggeredTimestamp = Date.now()
        iframe.postMessage({messages, triggeredTimestamp}, '*')
        localStorage.setItem(ANNOUNCEMENTS_LOCALSTORAGE_KEY, JSON.stringify([]))
    }
}

const MAP_BTN_NAME_TO_TRACKING_EVENT = new Map([
    [`okBtn`, CLOSE_REGULAR],
    [`crossBtn`, CLOSE_CROSS],
    [`scrolled`, SCROLL],
    [`loaded`, LOADED]
])

function addWindowListeners(context) {
    window.addEventListener(
        'message',
        (evt) => {
            if (evt.data && evt.data.name) {
                switch (evt.data.name) {
                    case sharedCommands.MARK_AS_READ:
                        markAsRead(evt.data)
                        context.emit(GET)
                        break
                    case sharedCommands.CLOSE_POPUP:
                        closeFrame(context)
                        break
                    case sharedCommands.SHOW_ANNOUNCEMENTS:
                        showAllMessages(evt.data)
                        break
                    case sharedCommands.TRACKING:
                        // tracking of this actions (loaded,crossBtn,okBtn,scrolled)
                        for (const announcement of allActiveAnnouncements) {
                            if (evt.data.action === 'scrolled') {
                                const scrolledAnnouncements =
                                    evt.data.params.scrolledAnnouncements
                                if (
                                    scrolledAnnouncements.includes(
                                        announcement.id
                                    )
                                ) {
                                    tracking(
                                        MAP_BTN_NAME_TO_TRACKING_EVENT.get(
                                            evt.data.action
                                        ),
                                        announcement,
                                        evt.data.params
                                    )
                                }
                            } else {
                                tracking(
                                    MAP_BTN_NAME_TO_TRACKING_EVENT.get(
                                        evt.data.action
                                    ),
                                    announcement,
                                    evt.data.params
                                )
                            }
                        }

                        break
                    case sharedCommands.LINK_CLICKED:
                        context.gameApi.invokeFn(
                            GAME_CALLBACK.PAGE_LOAD_STARTING,
                            evt.data.href
                        )
                        break
                    default:
                }
            }
        },
        false
    )
}

module.exports = {
    addWindowListeners,
    getDoNotShowMessages
}

module.exports.__internals = {
    markAsRead,
    getDoNotShowMessages,
    getMessages,
    closeFrame,
    showAllMessages,
    setAllActiveAnnouncements: (values) => {
        allActiveAnnouncements = values
    }
}
